import {
  CreateInclusionInterface,
  InclusionInterface,
  InclusionPackageInterface,
  QueryInclusionInterface,
  UpdateInclusionInterface,
} from "@/types/InclusionInterface";
import axiosClient from ".";

export default {
  async createInclusion(
    params: CreateInclusionInterface
  ): Promise<InclusionInterface> {
    return axiosClient
      .post("inclusion", params)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getInclusionsByQuery(
    params: QueryInclusionInterface
  ): Promise<InclusionInterface[]> {
    return axiosClient
      .get("inclusion", { params })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async updateInclusion(
    dto: UpdateInclusionInterface,
    id: string
  ): Promise<void> {
    return axiosClient
      .patch(`inclusion/${id}`, dto)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async deleteInclusion(id: string): Promise<void> {
    return axiosClient
      .delete(`inclusion/${id}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async uploadImageInclusion(
    builderId: string,
    image: FormData
  ): Promise<{
    Location: string;
    Key: string;
    format: string;
    updatedAt: string;
  }> {
    return axiosClient
      .post(`inclusion/images/${builderId}`, image)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async createInclusionForEstate(params: {
    type: string;
    estateId: string;
    inclusions?: InclusionPackageInterface[];
    categories?: Array<{ name: string; items: InclusionPackageInterface[] }>;
  }): Promise<InclusionInterface> {
    return axiosClient
      .post("inclusion/for-estate", params)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getInclusionsByEstateId(
    estateId: string
  ): Promise<InclusionInterface[]> {
    return axiosClient
      .get(`inclusion/estate/${estateId}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async bulkUploadInclusions(
    inclusionId: string,
    data: FormData
  ): Promise<InclusionInterface> {
    return axiosClient
      .post(`inclusion/bulk/${inclusionId}`, data)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },
};
